export enum QuestionsTab {
  Active = "Active",
  Inactive = "Inactive",
  All = "All",
}
